import React from "react";
import { Box, Stack, styled, Typography } from "@mui/material";

const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  width: "25%",
  margin: "0 10px",
  [theme.breakpoints.down("md")]: {
    width: "50%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "65%",
  },
}));

const DividerWithText = ({ title }) => {
  return (
    <Stack
      margin="10px 0px 5px 0px"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box
        sx={{
          borderBottom: "1px solid black",
          width: "100%",
        }}
      />
      <Title>{title}</Title>

      <Box
        sx={{
          width: "100%",
          borderBottom: "1px solid black",
        }}
      />
    </Stack>
  );
};

export default DividerWithText;
